import { Accordion } from 'jl-design-system/components/accordion/Accordion';
import { AccordionItem } from 'jl-design-system/components/accordion/accordion-item/AccordionItem';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { SelectablePartnerList } from '~/components';
import { triggerClickStylistDropdownAnalytics } from '../../../analytics/analytics.listener';
import styles from './ChosenPartnerAccordion.scss';

export class ChosenPartnerAccordion extends PureComponent {
  state = {
    isOpen: false,
  };

  onClick = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
    });
    triggerClickStylistDropdownAnalytics();
  };

  render() {
    const {
      partners,
      selectPartner,
      partnerTitle,
      partnerPrefix,
      selectablePartnersTitle,
      defaultPartnerText,
    } = this.props;
    const { isOpen } = this.state;

    if (partners.length < 2) {
      return null;
    }

    return (
      <Accordion className={styles.ChosenPartnerAccordion}>
        <AccordionItem
          animated
          key="ChosenPartnerAccordion"
          open={isOpen}
          header={
            <h6 className={styles.ChosenPartnerAccordionTitle}>
              {selectablePartnersTitle || `Choose your ${partnerTitle}`}
            </h6>
          }
          onClick={this.onClick}
        >
          <SelectablePartnerList
            handleSelect
            partners={partners}
            selectPartner={selectPartner}
            partnerTitle={partnerTitle}
            partnerPrefix={partnerPrefix}
            defaultPartnerText={defaultPartnerText}
          />
        </AccordionItem>
      </Accordion>
    );
  }
}

ChosenPartnerAccordion.propTypes = {
  partners: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  selectedPartner: PropTypes.shape({}).isRequired,
  partnerTitle: PropTypes.string.isRequired,
  partnerPrefix: PropTypes.string,
  selectablePartnersTitle: PropTypes.string,
  defaultPartnerText: PropTypes.string,
  selectPartner: PropTypes.func.isRequired,
};

ChosenPartnerAccordion.defaultProps = {
  selectablePartnersTitle: null,
  defaultPartnerText: null,
  partnerPrefix: undefined,
};
